'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = eauors;
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function minorTicksUpdate(selection, minorTicks, options) {
  selection.each(function (d) {
    var element = _d2.default.select(this);
    if (R.includes(d, minorTicks)) {
      element.select('line').attr('y2', R.path(['tick', 'minorSize'], options));
      element.select('line').style({
        'stroke-width': R.path(['tick', 'minorThickness'], options)
      });
      element.select('text').attr({
        'display': 'none'
      });
    } else {
      element.select('line').attr('y2', R.path(['tick', 'size'], options));
      element.select('text').attr({
        'display': 'block'
      });
    }
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    minorTicksUpdate: minorTicksUpdate
  });
}